// Although this layer interacts with store, I think it may be
// reusable because it's functionality seems to be unchanged from page to page.

import * as L from "leaflet";
import { IBoundLayer, IBoundLayerOptions } from "../../BoundLayer";
import { navigationLayerAdded } from "./asyncActions";

const NAVIGATION_LAYER_SET_VIEW_CALLED = "NAVIGATION_LAYER_SET_VIEW_CALLED";
interface ISetViewPayload {
  lat: number;
  lng: number;
  zoom: number;
}
export const setView = (
  payload: ISetViewPayload,
): IAction<ISetViewPayload> => ({
  type: NAVIGATION_LAYER_SET_VIEW_CALLED,
  payload,
});

const NAVIGATION_LAYER_FIT_GEOJSON_BOUNDS_CALLED =
  "NAVIGATION_LAYER_FIT_GEOJSON_BOUNDS_CALLED";
export const fitGeojsonBounds = (geoJson: object): IAction<object> => ({
  type: NAVIGATION_LAYER_FIT_GEOJSON_BOUNDS_CALLED,
  payload: geoJson,
});

const NAVIGATION_LAYER_INVALIDATE_SIZE_CALLED =
  "NAVIGATION_LAYER_INVALIDATE_SIZE_CALLED";
export const invalidateSize = (): IAction<void> => ({
  type: NAVIGATION_LAYER_INVALIDATE_SIZE_CALLED,
});

export default class NavigationLayer extends L.Layer implements IBoundLayer {
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    this.map = map;
    setTimeout(() => {
      this.options.dispatch(navigationLayerAdded());
    }, 10);
    return this;
  }

  public onRemove(map: L.Map) {
    this.map = null;
    return this;
  }

  public update(action: IAction<any>) {
    if (action.type === NAVIGATION_LAYER_SET_VIEW_CALLED) {
      const { lat, lng, zoom } = action.payload;
      this.map.setView({ lat, lng }, zoom);
    }
    if (action.type === NAVIGATION_LAYER_FIT_GEOJSON_BOUNDS_CALLED) {
      this.map.fitBounds(L.geoJSON(action.payload).getBounds());
    }
    if (action.type === NAVIGATION_LAYER_INVALIDATE_SIZE_CALLED) {
      this.map.invalidateSize();
    }
  }
}
